import { Role } from '@shared/enums/role.enum';
import {
  ProbateAccountSections,
  ProbateSections,
} from '../models/probate-sections.models';
import {
  faHome,
  faAddressCard,
  faRectangleList,
  faBookBookmark,
  faUsers,
  faFolder,
  faClipboardList,
  faShieldHalved,
  faSackDollar,
  faClipboard,
  faEllipsis,
  faNoteSticky,
  faMessage,
} from '@fortawesome/free-solid-svg-icons';
import { ProbateAppRoute } from '../models/probate-app-route.model';
import { TenantStepNavigation } from '@app/core/models/tenant-step-navigation.model';
import { AccountAppRoute } from '@app/core/models/account-app-route.model';

export const PROBATE_APP_ROUTES: Record<ProbateSections, ProbateAppRoute> = {
  [ProbateSections.HOME]: {
    id: ProbateSections.HOME,
    icon: faHome,
    label: 'Home',
    link: './home',
    alternativeRelativeLink: '../home',
    roles: [Role.Clerk, Role.Subscriber],
  },
  [ProbateSections.SUBSCRIBER]: {
    id: ProbateSections.SUBSCRIBER,
    icon: faAddressCard,
    label: 'Subscriber',
    link: './subscriber',
    alternativeRelativeLink: '../subscriber',
    roles: [Role.Clerk, Role.Subscriber],
  },
  [ProbateSections.DECEDENT]: {
    id: ProbateSections.DECEDENT,
    icon: faRectangleList,
    label: 'Decedent',
    link: './decedent',
    alternativeRelativeLink: '../decedent',
    roles: [Role.Clerk, Role.Subscriber],
  },
  [ProbateSections.WILL]: {
    id: ProbateSections.WILL,
    icon: faBookBookmark,
    label: 'Will',
    link: './will',
    alternativeRelativeLink: '../will',
    roles: [Role.Clerk, Role.Subscriber],
  },
  [ProbateSections.HEIRS_AND_INTERESTED_PARTIES]: {
    id: ProbateSections.HEIRS_AND_INTERESTED_PARTIES,
    icon: faUsers,
    label: 'Heirs',
    link: './heirs',
    alternativeRelativeLink: '../heirs',
    roles: [Role.Clerk, Role.Subscriber],
  },
  [ProbateSections.DOCUMENTS]: {
    id: ProbateSections.DOCUMENTS,
    icon: faFolder,
    label: 'Documents/Files',
    link: './documents',
    alternativeRelativeLink: '../documents',
    roles: [Role.Subscriber, Role.Clerk],
  },
  [ProbateSections.ESTATE]: {
    id: ProbateSections.ESTATE,
    icon: faClipboardList,
    label: 'Estate',
    link: './estate',
    alternativeRelativeLink: '../estate',
    roles: [Role.Clerk, Role.Subscriber],
  },
  [ProbateSections.BOND_SURETY]: {
    id: ProbateSections.BOND_SURETY,
    icon: faShieldHalved,
    label: 'Bond/Surety',
    link: './bond-surety',
    alternativeRelativeLink: '../bond-surety',
    roles: [Role.Clerk],
  },
  [ProbateSections.TAXES]: {
    id: ProbateSections.TAXES,
    icon: faSackDollar,
    label: 'Fees/Taxes',
    link: './taxes',
    alternativeRelativeLink: '../taxes',
    roles: [Role.Clerk],
  },
  [ProbateSections.FORMS]: {
    id: ProbateSections.FORMS,
    icon: faClipboard,
    label: 'Forms',
    link: './forms',
    alternativeRelativeLink: '../forms',
    roles: [Role.Clerk],
  },
  [ProbateSections.OTHER]: {
    id: ProbateSections.OTHER,
    icon: faEllipsis,
    label: 'Other',
    link: './other',
    alternativeRelativeLink: '../other',
    roles: [Role.Clerk, Role.Subscriber],
  },
};

export const PROBATE_APP_ROUTES_LIST: ProbateAppRoute[] = Object.values(
  PROBATE_APP_ROUTES,
).filter((route) => route.id !== ProbateSections.OTHER);

export const PROBATE_BASE_APP_STEP_NAVIGATION: TenantStepNavigation = {
  [ProbateSections.SUBSCRIBER]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.DECEDENT.alternativeRelativeLink,
  },
  [ProbateSections.DECEDENT]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.WILL.alternativeRelativeLink,
  },
  [ProbateSections.WILL]: {
    NEXT_STEP_ROUTE:
      PROBATE_APP_ROUTES.HEIRS_AND_INTERESTED_PARTIES.alternativeRelativeLink,
  },
};

export const PROBATE_SUBSCRIBER_APP_STEP_NAVIGATION: TenantStepNavigation = {
  ...PROBATE_BASE_APP_STEP_NAVIGATION,
  [ProbateSections.HEIRS_AND_INTERESTED_PARTIES]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.DOCUMENTS.alternativeRelativeLink,
  },
  [ProbateSections.DOCUMENTS]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.ESTATE.alternativeRelativeLink,
  },
  [ProbateSections.ESTATE]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.HOME.alternativeRelativeLink,
  },
};

export const PROBATE_CLERK_APP_STEP_NAVIGATION: TenantStepNavigation = {
  ...PROBATE_BASE_APP_STEP_NAVIGATION,
  [ProbateSections.HEIRS_AND_INTERESTED_PARTIES]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.DOCUMENTS.alternativeRelativeLink,
  },
  [ProbateSections.DOCUMENTS]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.ESTATE.alternativeRelativeLink,
  },
  [ProbateSections.ESTATE]: {
    NEXT_STEP_ROUTE: PROBATE_APP_ROUTES.BOND_SURETY.alternativeRelativeLink,
  },
  [ProbateSections.BOND_SURETY]: {
    NEXT_STEP_ROUTE: null,
  },
};

export const ACCOUNT_ROUTES: AccountAppRoute[] = [
  {
    id: ProbateAccountSections.NOTES,
    icon: faNoteSticky,
    label: 'Notes',
    link: './notes',
    roles: [Role.Clerk, Role.Subscriber],
  },
  {
    id: ProbateAccountSections.MESSAGES,
    icon: faMessage,
    label: 'Messages',
    link: './messages',
    roles: [Role.Clerk],
  },
];
